export enum ViewFilterAdvancedBlock {
  Root = 'ViewFilterAdvanced',
}

export enum ViewFilterAdvancedElement {
  Content = 'content',
}
